import 'jquery';
import Cookies from 'js-cookie';

// Newsletter Slider
const $newsletterSlider = $('.js-newsletter-slider');
const $toggleSlider = $('.js-toggle-slider');
const ACTIVE_CLASS = 'is-active';

// Sticky Item
const $stickyItem = $('.js-newsletter-sticky');
const $toggleStickyChevron = $('.js-toggle-sticky-chevron');
const $stickyToggleSlider = $('.js-sticky-toggle-slider');
const STICKY_SLIDER_COOKIE = 'StickySliderCookie';

const cookieState = {
  NEVER_SEEN: 0,
  SEEN: 1,
  NEVER_SHOW: 2,
};

$(document).ready(() => {
  if ($newsletterSlider.length && $toggleSlider.length) {
    $toggleSlider.click(() => {
      $newsletterSlider.toggleClass(ACTIVE_CLASS);

      // Always hide the sticky item when the main slider toggles
      $stickyItem.removeClass('transform-y');
      $toggleStickyChevron.hide();
    });
  }
});

function autoCloseSlider() {
  const $finalStep = $('.js-slider-final-step');
  if ($finalStep.length === 0) {
    return;
  }

  setTimeout(() => {
    $newsletterSlider.removeClass(ACTIVE_CLASS);
  }, 3000);
}

// Sticky Item Binding
$(document).ready(() => {
  if ($stickyItem.length && $toggleStickyChevron.length) {
    // Generates a date 5 minutes in the future
    const date = new Date();
    date.setTime(date.getTime() + (5 * 60 * 1000));

    // Switch on the cookie value using an enum
    switch (Cookies.get(STICKY_SLIDER_COOKIE)) {
      case `${cookieState.NEVER_SEEN}`:
        if ($('.js-generic-popup').length === 0) {
          showStickyPopup();
        }
        break;

      case `${cookieState.SEEN}`:
        // Hide the popup if it's been seen
        Cookies.set(STICKY_SLIDER_COOKIE, cookieState.NEVER_SHOW, {
          expires: date,
        });
        break;

      case `${cookieState.NEVER_SHOW}`:
        // Do nothing once it's set to 'never show'
        break;

      default:
        // Hits this on the first page load as the value is undefined in the cookie
        Cookies.set(STICKY_SLIDER_COOKIE, cookieState.NEVER_SEEN, {
          expires: date,
        });
        break;
    }
  }

  // Bind the button to hide the popup and display the envelope slider button
  $toggleStickyChevron.click(() => {
    hideStickyPopup();
    seenStickyPopup();
  });

  //
  $stickyToggleSlider.click(() => {
    seenStickyPopup();
  });
});

function showStickyPopup() {
  // Show the popup if its 'never seen'
  setTimeout(() => {
    $stickyItem.addClass('transform-y');
    $toggleStickyChevron.show();
  }, 1250);
}

function hideStickyPopup() {
  $stickyItem.removeClass('transform-y');
  $toggleStickyChevron.hide();
}

function seenStickyPopup() {
  const date = new Date();
  date.setTime(date.getTime() + (5 * 60 * 1000));
  Cookies.set(STICKY_SLIDER_COOKIE, cookieState.SEEN, {
    expires: date,
  });
}

Sys.WebForms.PageRequestManager.getInstance().add_endRequest(autoCloseSlider);
